var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrowRight = function SvgIcoArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 12,
    fill: "none",
    viewBox: "0 0 6 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 1 4 5-4 5"
  })));
};
export default SvgIcoArrowRight;